/**
 * 扣款记录
 *
 * @author FJJ
 * @version 1.0
 *
 * Copyright 2022, all rights reserved. Essa.cn
 * */
import React from 'react'
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import Lang from "@components/Lang/Lang";
import AutoFetchTable from "@components/AutoFetchTable/AutoFetchTable";
import {getColumns} from "../component/PaymentColumns";
import "./index.less";

export default class PaymentCheckOutRecord extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            //加载中
            loading: true,
            // 列
            columns: getColumns(),
            searchFormOptions:[
                {
                    name:'keyword',
                    cnPlaceholder:'搜索客户编号',
                    cnPlaceholderId:'SouSuoKeHuBianHao ',
                    hiddenLabel:true,
                },
                {
                    name:'time',
                    cnPlaceholder:[Lang({id:'KaiShiShiJian',default:'开始时间'}),Lang({id:'JieShuShiJian',default:'结束时间'})],
                    cnPlaceholderId:['KaiShiShiJian','JieShuShiJian'],
                    searchRange:['startTime','endTime'],
                    type:'DateRangePicker',
                    width:300,
                    hiddenLabel:true,
                    canSearch:false,
                },
            ],
        };
    }
    onRefTabOne = (ref) =>  this.onRefTabChildOne = ref;
    componentDidMount() {
        // this.getData();
    }
    render(){
        const { columns,searchFormOptions } = this.state;
        return (
            <>
                <CommonBreadcrumb
                    list={[
                        { name:Lang({id: 'KouJianDengJi', default: '扣减登记'}),link:"/financeManagement/paymentCheckOut"},
                        { name: Lang({id: 'KouJianJiLu', default: '扣减记录'})}
                    ]}
                ></CommonBreadcrumb>
                <div className={"main-wrap"}>
                    <div className="mb_16 font-20">{Lang({id: 'QuanBuKouJianJiLu', default: '全部扣减记录'})}</div>
                    {/*表格*/}
                    <AutoFetchTable columns={columns}
                                    searchFormOptions={searchFormOptions}
                                    onRef={this.onRefTabOne}
                                    exportSetting = {
                                        {
                                            exportUrl: '/data/bpms/jreport/mg/fexiao/fin/deduction/print',
                                            exportTemplate: 'MgFenxiaoDeductionReport',
                                            authName:'PaymentCheckOut-Record-Export-Button'
                                        }
                                    }
                                    scroll={{ x: 1200 }}
                                    flagShowReset = {false}
                                    pageSize={50}
                                    fetchApi={'/service/mg/fin/ddp/deduction-item/list'}>
                    </AutoFetchTable>
                </div>
            </>
        )
    }
}

